import React from 'react'
import injectSheet from 'react-jss'
import styles from './conclusion.styles'
import { ModalFooter } from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'

const Conclusion = ({ classes, importedStudentsCount }) => (
  <>
    <div className={classes.container}>
      <p>
        We have now successfully linked Pobble to your MIS. There are{' '}
        <strong>{importedStudentsCount}</strong> pupil
        {importedStudentsCount > 1 ? 's' : ''} in your school.
      </p>
    </div>
    <ModalFooter className={classes.footer}>
      <Button tall href={'/dashboard'}>
        Done
      </Button>
    </ModalFooter>
  </>
)

export default injectSheet(styles)(Conclusion)
